import React from 'react';
import { Button } from '@aws-amplify/ui-react';

const JSignOut = (props) => {

  return (
    <Button
      variation="primary"
      size="large"
      onClick={props.signOut}>Abmelden</Button>
  )
}

export default JSignOut;